var map = {
	"./CourseManagement/routes.js": "9d1c",
	"./Courses/routes.js": "3cd1",
	"./Education/Courses/routes.js": "58037",
	"./Education/Schedule/routes.js": "03b6",
	"./Education/Tasks/routes.js": "c762",
	"./Education/Teach/routes.js": "d3cb",
	"./Groups/routes.js": "172f",
	"./Mentored/routes.js": "2236",
	"./Mentoring/routes.js": "d69d",
	"./Modules/routes.js": "8267",
	"./PaymentSystem/routes.js": "8ca4",
	"./Tags/routes.js": "d892",
	"./Tasks/routes.js": "bc10",
	"./Teachers/routes.js": "8726",
	"./UserSettings/routes.js": "c975",
	"./Webinars/routes.js": "6b4b",
	"./Widgets/routes.js": "4c2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ffe";